import React from 'react';

const Spinner = ({ message = "Chargement..." }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8">
      <div className="w-12 h-12 border-4 border-brand-blue border-t-transparent rounded-full animate-spin"></div>
      <p className="mt-4 text-gray-600">{message}</p>
    </div>
  );
};

export default Spinner;